/* ---- Lock Header on Scroll ---- */
(function($) {

  /*
  var lastScrollTop = 0, delta = 100;
  $(window).scroll(function(){

    var height = $(window).scrollTop();
    var nowScrollTop = $(this).scrollTop();

    if(Math.abs(lastScrollTop - nowScrollTop) >= delta){

      if (nowScrollTop > lastScrollTop){
        if (height > 300) {
          //$('#header_desktop_scroll').fadeIn(300, 'easeInOutQuad');
          $('#header_desktop_scroll').css('top', 0);
        }
      } else {
        //$('#header_desktop_scroll').fadeOut(300, 'easeInOutQuad');
        $('#header_desktop_scroll').css('top', -150);
      }

      lastScrollTop = nowScrollTop;

    }
  });
  */

})(jQuery);
